
import { combineReducers } from "redux";
import * as actionTypes from "../constants/actionTypes";
import typologies from "./typologies";
import markets from "./markets";
import searchString from "./searchString";
import categories from "./categories";
import tags from "./tags";
import properties from "./properties";
import { Action } from "../actions/filters";

// export type FiltersState = {
//   +typologies: TypologiesState,
//   +markets: MarketsState,
//   +searchString: SearchStringState,
//   +categories: CategoriesState,
//   +tags: TagsState,
//   +properties: PropertiesState,
//   +isLoading: boolean,
//   +hasError: boolean,
//   +errorMessage?: string
// };

export type FiltersState = ReturnType<typeof filters>;

const isLoading = (state: boolean = false, action: Action) => {
  switch (action.type) {
    case actionTypes.GET_FILTERS:
    case actionTypes.SET_MARKET:
    case actionTypes.TOGGLE_MARKET_ON_SELECTED_LIST:
      return true;

    case actionTypes.GET_FILTERS_SUCCESS:
    case actionTypes.GET_FILTERS_ERROR:
      return false;

    default:
      return state;
  }
};

const hasError = (state: boolean = false, action: Action) => {
  switch (action.type) {
    case actionTypes.GET_FILTERS:
    case actionTypes.GET_FILTERS_SUCCESS:
      return false;

    case actionTypes.GET_FILTERS_ERROR:
      return true;
    default:
      return state;
  }
};

const errorMessage = (state: string | null = null, action: Action) => {
  switch (action.type) {
    case actionTypes.GET_FILTERS:
    case actionTypes.GET_FILTERS_SUCCESS:
      return null;

    case actionTypes.GET_FILTERS_ERROR:
      const { error } = action.payload;
      return error;
    default:
      return state;
  }
};

const filters = combineReducers({
  typologies,
  markets,
  searchString,
  categories,
  tags,
  properties,
  isLoading,
  hasError,
  errorMessage
});

export default filters;
